import React, { useState } from 'react'
import resolveProps from '../../utils/resolveProps'
import { ShortcutProps} from './types'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: ['inverse'],
  states: ['loading']
}

export default function Shortcut(props: ShortcutProps
   & React.AnchorHTMLAttributes<HTMLAnchorElement> ) {
  const { icon, loading, children, target, inverse,  href, ...rest } = props

  return (
    <a
      {...rest}
      className={`${resolveProps(props, config, 'Shortcut')}${loading ? ' mdn-Skeleton' : ''} `}
      href={href}
      target={target}
    >
      <span
        className={`${loading ? 'mdn-Skeleton-item mdn-Skeleton-icon' : 'mdn-Shortcut-icon mdn-Icon-' + icon + ' mdn-Icon--md'}`}
      ></span>
      <p className={`${loading ? 'mdn-Skeleton-item mdn-Skeleton-text' : 'mdn-Shortcut-text '}`}>{!loading ? children : ''}</p>
    </a>
  )
}
